<style scoped>

  .main {
    flex-direction: column;
    height: 100%;
    min-width: 1400px;
    overflow: hidden;
  }

  .inner {
    /*position: relative;*/
    /*width: 1400px;*/
    /*height: 600px;*/
    /*margin: 0 auto;*/
  }
  .iner_text{
    font-size:16px;
    color:#000;
  }

  .header {
    font-size:16px;
    flex: 0 0 auto;
    height: 6.875em;
  }

  .header img {
    font-size:16px;
    width:100%;
    height:100%;
    float: left;
    margin-top:1.562em;
  }

  .header span {
    float: left;
    margin-left:2.5em;
    font-size: 16px;
    line-height: 6.875em;
    color: #000;
  }

  .content {
    font-size:16px;
    height:38.125em;
    width:100%;
    background: url("https://oss.aliyuncs.com/hmcrm/beidou/hash/new_hrcm_login_bg.jpg") no-repeat center;
    background-size: cover;
  }

  .content_background {
    /*position: absolute;*/
    /*width:1920px;*/
    /*z-index: -1;*/
    /*height: 600px;*/
    /*top: 0;*/
    /*left: 50%;*/
    /*transform: translateX(-50%);*/
  }

  .main_text {
    position: absolute;
    top: 130px;
    left: 50%;
    color: #fff;
    font-size: 30px;
    font-weight:700;
    margin-left: -684px;
    line-height: 58px;
    font-weight: 500;
  }

  .main_text_data {
    font-size: 24px;
  }

  .footer {
    width:100%;
    height: 30px;
    color: #888888;
    text-align: center;
    line-height: 30px;
    font-family: '微软雅黑';
    font-size: 12px;
    margin-top:8.333em;
  }

  .login_box {
    float: right;
    margin-top: 8.125em;
    margin-right: 23.44%;
    padding: 28px;
    width: 348px;
    background: #fff;
    border-radius: 2px;
    position: relative;
  }

  .select_company_title {
    text-align: center;
    color: #43484c;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .select_company_main {
    position: relative;
    margin: 30px 0;
  }

  .last_company {
    position: absolute;
    top: 20px;
    left: 0;
    cursor: pointer;
  }

  .next_company {
    position: absolute;
    top: 20px;
    right: 0;
    cursor: pointer;
  }

  .select_company_show {
    overflow: hidden;
    width: 292px;
    height: 68px;
  }

  .select_company_all {
    position: relative;
    transition: all 0.5s;
    width: 460px;
    top: 0;
    left: 8px;
  }

  .select_company_all li {
    float: left;
    width: 60px;
    height: 46px;
    margin: 10px 16px;
    text-align: center;
    opacity: 0.8;
    cursor: pointer;
    transition: all 0.5s;
    border-radius: 2px;
  }

  .select_company_all li img {
    width: 46px;
  }

  .select_company_all .company_selected {
    transform: scale(1.4);
    opacity: 1;
  }

  .select_company_name {
    text-align: center;
    color: #73787c;
    font-size: 14px;
    margin-top: 10px;
  }

  .company_img {
    background: #5b95f9;
  }

  .main_bottom {
    margin-top: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .forger_password {
    float: right;
    font-size: 12px;
    color: #2d78f4;
    cursor: pointer;
  }

  .go-to-wx {
    font-size: 12px;
    color: #2d78f4;
    cursor: pointer;
  }

  .go-to-ding {
    font-size: 12px;
    color: #2d78f4;
    cursor: pointer;
    margin-left: 8px;
  }

  .forger_password:hover {
    text-decoration: underline;
  }

  .connect_us {
    font-size: 12px;
    float: right;
    color: #ccc;
    cursor: pointer;
  }

  .connect_us:hover {
    text-decoration: underline;
  }

  .warning_message {
    margin-top: 12px;
    color: red;
    height: 24px;
  }

  .repeat_inner_head_left{
    float:left;
    margin-left:19%;
    width:31%;
  }

  .repeat_inner_head_logo{
    font-size:16px;
    width:8.56em;
  }

  .repeat_inner_head_right a{
    display: block;
    float:right;
    margin-right:26%;
    font-size:12px;
    margin-top:3.833em;
    color:#000;
  }

  .forget_wrap,
  .forget_img_wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    display: flex;
  }

  .forget_warn {
    width: 450px;
    height: 250px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -225px;
    margin-top: -270px;
    background: #fff;
    z-index: 201;
  }

  .forget_title {
    height: 50px;
    line-height: 50px;
    width: 100%;
    background: rgb(239, 239, 239);
    font-size: 14px;
    padding: 0 10px;
  }

  .forget_main .forget_warn_title {
    font-size: 16px;
    color: orange;
    text-align: center;
    margin-bottom: 20px;
  }

  .forget_main p {
    line-height: 28px;
    font-size: 14px;
  }

  .forget_img {
    display: inline-block;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .wx_login_container {
    width: 100%;
    height: 300px;
    text-align: center;
  }

  .wx_login_icon{
    width:18px;
    height:18px;
    border-radius: 10px;
  }

  .login-switch{
    position: absolute;
    right:5px;
    top:8px;
    cursor: pointer;
  }
  .login-switch img{
    display: block;
    width:52px;
    height:52px;
  }
  .company_list_null{
    height:300px;
    line-height: 300px;
    text-align: center;
    font-size:14px;
    color:#ff9900;
  }

</style>
<template>
  <div class="adapatin_main main">
    <!-- 导航 -->
    <div class="adapation_header header">
      <div class="repeat_inner_head_left">
        <div class="repeat_inner_head_logo adapation_repeat_inner_head_logo">
          <img class="logo" src="https://oss.aliyuncs.com/hmcrm/beidou/home_img/new_beidou_logo_login.png" />
        </div>
        <span class="iner_text adapation_iner_text">高效务实，智慧影楼</span>
      </div>
      <div class="adapation_repeat_inner_head_right repeat_inner_head_right">
        <a href="https://qiein.com/" target="_blank">官方网站</a>
      </div>
    </div>

    <!-- 登录 -->
    <div class="content adapation_content">
      <div class="repeat_inner">

        <div class="login_box">

          <!-- 登录切换 -->
          <!--<div class="login-switch" @click="loginSwitch" v-if="!bShowChoseCompany">-->
            <!--<img :src="loginSwitchIcon" alt="切换微信登录" />-->
          <!--</div>-->

          <!-- 手机号码登录 -->
          <template v-if="loginMethod=='phone'">
            <p style="color: #666;font-weight: 700;font-size: 16px">账户登录</p>
            <p class="warning_message" v-text="warningMessage"></p>
            <div v-if="!bShowChoseCompany">
              <i-Input type="text" size="large" :maxlength='11' @on-blur="fUserBlur" @on-enter="fDoLogin" v-model="userInfo.user"
                style="margin-top: 10px;">
                <Icon type="person" slot="prepend"></Icon>
              </i-Input>
              <i-Input type="password" size="large" v-model="userInfo.password" @on-enter="fDoLogin" style="margin-top: 20px;">
                <Icon type="locked" slot="prepend"></Icon>
              </i-Input>
              <div v-if="bShowCode" style="position: relative;margin-top: 20px;">
                <i-Input type="text" v-model="userInfo.code" @on-enter="fDoLogin" size="large" style="width: 200px;">
                  <span slot="prepend">验证码</span>
                </i-Input>
                <img @click="fChangeCodeImg" :src="codeImg" style="vertical-align: bottom;height: 36px;position: absolute;right: 0;top: 1px;border: 1px solid;"
                  alt="">
              </div>
            </div>
          </template>

          <!-- wx登录 -->
          <!--<template v-else-if="loginMethod=='wx'">-->
            <!--<template v-if="!bShowChoseCompany">-->
              <!--<p style="color: #666;font-weight: 700;font-size: 16px">-->
                <!--<img src="https://oss.aliyuncs.com/hmcrm/beidou/source/src_weichat.png" alt="" style="width:20px;border-radius: 10px;vertical-align: text-bottom">-->
                <!--微信登录-->
              <!--</p>-->
              <!--<wx-auth v-if="companyListState" @on-success="handleCompanyListByWx" class="wx_login_container"></wx-auth>-->
              <!--<div v-if="!companyListState" class="company_list_null">请先绑定公司</div>-->
            <!--</template>-->
          <!--</template>-->

          <!-- <template v-else-if="loginMethod=='ding'">
            <template v-if="!bShowChoseCompany">
              <p style="color: #666;font-weight: 700;font-size: 16px">钉钉登录</p>
              <ding-auth @get-code="getCompanyListByDing" class="wx_login_container"></ding-auth>
            </template>
          </template> -->

          <!-- 选择公司 -->
          <div v-if="bShowChoseCompany" class="select_company">
            <p class="select_company_title">请确认登录的公司</p>
            <div class="select_company_main">
              <span @click="fChooseLastCompany" class="last_company">
                <Icon type="chevron-left"></Icon>
              </span>
              <span @click="fChooseNextCompany" class="next_company">
                <Icon type="chevron-right"></Icon>
              </span>
              <div class="select_company_show">
                <ul class="select_company_all" :style="{left: companyBoxLeft+'px',width: 92*companyList.length + 'px'}">
                  <li v-for="(item,index) in companyList" @click="fChooseCompany(index)" :class="(-index*92+100)===companyBoxLeft?'company_img company_selected': 'company_img'">
                    <img v-if="item.img" :src="item.img" style="width:100%;margin-top: 10px;" alt="">
                    <img v-else="!item.img" src="https://hmcrm.oss-cn-hangzhou.aliyuncs.com/beidou/icon_flag/companyIcon.png"
                      alt="">
                  </li>
                </ul>
              </div>
              <p class="select_company_name" v-text="selectedCompany.name"></p>
            </div>
          </div>
          <!-- 控制显示登录按钮 -->
          <template v-if="showLoginBtn">
            <Button type="primary" size="large" @click="fDoLogin" long style="margin-top: 30px;margin-bottom: 10px;">
              立即登录
            </Button>
          </template>
          <p class="main_bottom" v-if="loginMethod=='phone'">
            <!--<img class="wx_login_icon" src="https://oss.aliyuncs.com/hmcrm/beidou/source/src_weichat.png" alt="草莓卷微信登录">-->
            <!--<span class="go-to-wx" @click="goToWxLogin" style="margin-left:2px;flex:2;">微信登录</span>-->
            <span class="go-to-wx" style="margin-left:2px;flex:2;"></span>
            <!-- <span class="go-to-ding" @click="goToDingLogin">钉钉登录</span> -->
            <span class="forger_password" @click="bForgetIsShow = true">忘记密码？</span>
            <!--<span class="connect_us">联系我们</span>-->
          </p>
        </div>
      </div>
    </div>

    <!-- 底部文案 -->
    <div class="adapation_footer footer">版权所有 © {{new Date().getFullYear()}}草莓卷All rights reserved. Version v1.0 浙ICP备16021666号-1</div>

    <!--忘记密码-->
    <Modal v-model="bForgetIsShow" title="找回密码">
      <p style=" font-size: 16px;color: orange;text-align: center; margin-bottom: 20px;">你好粗心大意啊！</p>
      <p style="padding-left: 50px;line-height: 28px;font-size: 14px;">1. 请联系您的管理员，在系统“人事中心”重置您的密码</p>
      <p style="padding-left: 50px;line-height: 28px;font-size: 14px;">2. 通过企业钉钉，在“智慧影楼”-“个人中心”中重置密码
        <Icon @click.native="fShowForgetImg" type="ios-help-outline" style="font-size:16px;margin-left: 5px;cursor: pointer;"></Icon>
      </p>
      <div slot="footer" style="text-align: right">
        <Button type="primary" @click="bForgetIsShow = false">确定</Button>
      </div>
    </Modal>

    <!--找回密码流程图-->
    <div class="forget_img_wrap" v-if="bImgShow" @click="bImgShow = false">
      <img src="https://hmcrm.oss-cn-hangzhou.aliyuncs.com/beidou/help/forgetpwd.jpg" class="forget_img" />
      <span style="position: absolute;top: 10px;right: 10px;cursor: pointer;" @click="bImgShow = false">
        <Icon type="ios-close-outline" style="font-size:36px;color: #fff;"></Icon>
      </span>
    </div>
  </div>
</template>

<script>
  import Cookies from "js-cookie";
  import {
    HOST
  } from "../../common/config";
  import dingAuth from "../../components/sing-in/ding-auth.vue";
  import wxAuth from "../../components/sing-in/wx-auth.vue";
  import axios from "axios";

  export default {
    name: "",
    data() {
      return {
        loginSwitchIcon: 'https://oss.aliyuncs.com/hmcrm/beidou/source/login-switch-wechat.png',
        bForgetIsShow: false,
        bImgShow: false,
        warningMessage: "",
        bShowCode: false,
        bShowChoseCompany: false,
        codeImg: "",
        companyBoxLeft: 0,
        companyList: [],
        selectedCompany: {},
        companyListState:true,
        userInfo: {
          user: "",
          password: "",
          code: ""
        },
        loginMethod: 'phone',
        passwordLimit: {
          open: false
        },
        //wx
        wxToken: null,
        //钉钉
        dingCode: null
      };
    },
    components: {
      dingAuth,
      wxAuth
    },

    computed: {
      //登录按钮显示
      showLoginBtn() {
        return (this.loginMethod == 'phone') || (this.loginMethod == 'wx' && this.companyList.length)
      }
    },
    mounted(){
      this.$store.commit('setUserInfoInitFlag', false)
    },
    methods: {
      //切换登录
      loginSwitch() {
        this.companyListState = true
        if (this.loginMethod == 'phone') {
          this.loginMethod = 'wx';
          this.loginSwitchIcon = 'http://oss.aliyuncs.com/hmcrm/beidou/source/login-switch-comuter.png'
        } else if (this.loginMethod == 'wx') {
          this.loginMethod = 'phone';
          this.loginSwitchIcon = 'http://oss.aliyuncs.com/hmcrm/beidou/source/login-switch-wechat.png'
        }
      },

      //登录验证
      fDoLogin() {
        let phoneReg = /^(13|14|15|16|17|18|19)\d{9}$/;
        this.userInfo.user = this.userInfo.user.trim();
        this.userInfo.password = this.userInfo.password.trim();
        if (!phoneReg.test(this.userInfo.user)) {
          this.warningMessage = "请输入正确的手机号码";
          return false;
        }
        if (!this.userInfo.password) {
          this.warningMessage = "请输入密码";
          return false;
        }
        if (!this.userInfo.code && this.bShowCode) {
          this.userInfo.code = this.userInfo.code.trim();
          this.warningMessage = "请输入验证码";
          return false;
        }
        this.warningMessage = "";
        if (this.selectedCompany.id) {
          //根据登录方式
          if (this.loginMethod == 'phone') {
            this.fLogin();
          } else if (this.loginMethod == 'wx') {
            this.loginWithCidByWeChat();
          } else {
            this.loginWithCidByDing();
          }
        } else {
          this.fGetCompanyList();
        }
      },
      //获取公司列表
      fGetCompanyList() {
        this.$http.post('login/get_company_list_by_phone', {
          userName: this.userInfo.user,
          password: this.userInfo.password,
          verifyCode: this.userInfo.code,
        }).then((data) => {
          if (data.code === 100000) {
            this.handleGetCompanyList(data, this.fLogin)
          } else {
            this.fUserBlur();
            this.$Message.error(data.msg);
          }
        })
      },
      //处理公司登录的
      handleGetCompanyList(data, login) {
        if (data.data.length === 1) {
          this.selectedCompany.id = data.data[0].id;
          login();
        } else {
          this.companyList = data.data.map(item => {
            return {
              name: item.companyName,
              id: item.id,
              img: item.logo
            };
          });
          this.companyBoxLeft = 100;
          this.bShowChoseCompany = true;
        }
      },
      //手机号登录
      fLogin() {
        this.$http.post('login/login_by_phone', {
          username: this.userInfo.user,
          password: this.userInfo.password,
          code: this.userInfo.code,
          companyId: this.selectedCompany.id
        }).then((data) => {
          this.bShowCode = false;
          if (data.code === 100000) {
            //success
            if (this.userInfo.user === data.data.phone) {
              Cookies.set("token", data.data.token);
              Cookies.set("cid", data.data.companyId);
              Cookies.set("uid", data.data.id);
              this.$router.push("/login/back");
            } else {
              window.location.reload();
            }
          } else if (data.code === 999999) {
            // add code
            this.warningMessage = data.msg;
            if (data.data.isValidateCodeLogin) {
              this.bShowCode = true;
              this.fChangeCodeImg();
            } else {
              this.bShowCode = false;
            }
            this.fChangeCodeImg();
          } else if (data.code === 999998) {
            // ip limit
            Cookies.set("token", data.data.token);
            Cookies.set("cid", data.data.companyId);
            Cookies.set("uid", data.data.id);
            this.$router.push("/ip_limit");
          } else if (data.code === 999997) {
            // password limit
            Cookies.set("token", data.data.token);
            Cookies.set("cid", data.data.companyId);
            Cookies.set("uid", data.data.id);
            this.passwordLimit.open = true;
          } else {
            this.fUserBlur();
            this.warningMessage = data.msg;
          }
        })
      },
      fChooseLastCompany() {
        if (this.companyBoxLeft < 100) {
          this.companyBoxLeft = this.companyBoxLeft + 92;
        }
      },
      fChooseNextCompany() {
        if (this.companyBoxLeft > 192 - 92 * this.companyList.length) {
          this.companyBoxLeft = this.companyBoxLeft - 92;
        }
      },
      fChooseCompany(index) {
        this.companyBoxLeft = 100 - index * 92;
      },
      //验证码
      fChangeCodeImg() {
        this.userInfo.code = "";
        let timestamp = new Date().valueOf();
        this.codeImg =
          HOST +
          "/login/verify_code?phone=" +
          this.userInfo.user +
          "&timestamp=" +
          timestamp;
      },
      //验证手机号码
      fUserBlur() {
        this.userInfo.user = this.userInfo.user.trim();
        let phoneReg = /^(13|14|15|16|17|18|19)\d{9}$/;
        let value = this.userInfo.user;
        if (phoneReg.test(value)) {
          this.$http.get('login/need_verity_code', {
            params: {
              phone: value
            }
          }).then((data) => {
            if (data) {
              this.bShowCode = true;
              this.fChangeCodeImg();
            } else {
              this.bShowCode = false;
            }
          })
        } else {
          this.warningMessage = "请输入正确的手机号码";
        }
      },
      //忘记密码
      fShowForgetImg() {
        this.bImgShow = true;
        this.bForgetIsShow = false;
      },
      //WX 登录
      goToWxLogin() {
        this.loginMethod = 'wx';
      },
      // 微信获取公司列表
      handleCompanyListByWx(data) {
        let companyList = data.companyList;
        this.wxToken = data.token;
        if (companyList.length == 1) {
          this.selectedCompany = {
            name: companyList[0].companyName,
            id: companyList[0].companyId,
            staffId: companyList[0].staffId
          }
          this.loginWithCidByWeChat();
        } else if(companyList.length > 1) {
          this.companyList = companyList.map(item => {
            return {
              name: item.companyName,
              id: item.companyId,
              staffId: item.staffId
              // img: item.logo
            };
          });
          this.companyBoxLeft = 100;
          this.bShowChoseCompany = true;
        } else if(!companyList.length){
          this.companyListState = false
          this.$Message.warning('请先绑定公司')
        }
      },
      //根据公司登录
      loginWithCidByWeChat() {
        axios.get('https://apollo.qiein.com/third_login/get_user_by_wechat_token', {
          params: {
            token: this.wxToken,
            companyId: this.selectedCompany.id,
            staffId: this.selectedCompany.staffId
          }
        }).then((data) => {
          if (data.code === 100000) {
            Cookies.set("token", data.data.token);
            Cookies.set("cid", data.data.cid);
            Cookies.set("uid", data.data.uid);
            this.$router.push("/login/back");
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      //WX 登录
      goToDingLogin() {
        this.loginMethod = 'ding';
      },
      // 钉钉获取公司列表
      getCompanyListByDing(code) {
        this.dingCode = code;
        this.$http.get('login/get_company_list_by_ding', {
          params: {
            code: this.dingCode
          }
        }).then((data) => {
          if (data.code === 100000) {
            this.handleGetCompanyList(data, this.loginWithCidByDing)
          } else {
            this.fUserBlur();
            this.$Message.error(data.msg);
          }
        })
      },
      //根据公司登录
      loginWithCidByDing() {
        this.$http.get('login/login_by_ding', {
          params: {
            code: this.dingCode,
            cid: this.selectedCompany.id
          }
        }).then((data) => {
          if (data.code === 100000) {
            Cookies.set("token", data.data.token);
            Cookies.set("cid", data.data.companyId);
            Cookies.set("uid", data.data.id);
            this.$router.push("/login/back");
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
    },
    watch: {
      companyBoxLeft() {
        let index = (100 - this.companyBoxLeft) / 92;
        this.selectedCompany = JSON.parse(
          JSON.stringify(this.companyList[index])
        );
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/view/login/login.vue